import { render, staticRenderFns } from "./ComplaintStatusLeyend.vue?vue&type=template&id=e127f3f4&scoped=true&"
import script from "./ComplaintStatusLeyend.vue?vue&type=script&lang=js&"
export * from "./ComplaintStatusLeyend.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintStatusLeyend.vue?vue&type=style&index=0&id=e127f3f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e127f3f4",
  null
  
)

export default component.exports